<div style="display: flex; overflow-x: hidden;" >
<!--     <avs-faq-menu>
    </avs-faq-menu> -->
    <router-outlet>
    </router-outlet>
</div>